import * as React from "react";
import {
    Button,
    Dropdown,
    DropdownContent,
    DropdownItem,
    DropdownTrigger,
} from "@jhool-io/fe-components";
import ChevronDownIcon from "../../../../icons/ChevronDown";
import {
    BeforeAiSessionNoteReview,
    useAiSessionNoteReview,
} from "../../../../context/AiSessionNoteReviewContext";
import AiSessionNoteWriter, {
    AiSessionNoteWriterProps,
} from "../AiSessionNoteWriter/AiSessionNoteWriter";

interface AiSessionNoteActionsProps
    extends Omit<AiSessionNoteWriterProps, "renderTrigger"> {
    beforeReview?: BeforeAiSessionNoteReview;
}

export default function AiSessionNoteActions({
    beforeReview,
    ...writerProps
}: AiSessionNoteActionsProps) {
    const {
        phase,
        isPending: isReviewPending,
        runReview,
    } = useAiSessionNoteReview();
    const [canGenerate, setCanGenerate] = React.useState(true);

    return (
        <AiSessionNoteWriter
            {...writerProps}
            renderTrigger={({
                getCanOpen,
                isActive: isWriterActive,
                isGenerating,
                openDialog,
            }) => {
                const isBusy = isWriterActive || isReviewPending;
                let label = "Mantle AI";
                if (isGenerating) label = "Generating…";
                if (phase === "saving") label = "Saving…";
                if (phase === "reviewing") label = "Reviewing…";

                return (
                    <Dropdown
                        onOpenChange={(isOpen) => {
                            if (isOpen) setCanGenerate(getCanOpen());
                        }}
                    >
                        <DropdownTrigger asChild>
                            <Button
                                type="button"
                                iconRight={<ChevronDownIcon />}
                                disabled={isBusy}
                            >
                                {label}
                            </Button>
                        </DropdownTrigger>
                        <DropdownContent
                            align="end"
                            width="auto"
                            className="max-w-[calc(100vw-2rem)]"
                        >
                            <DropdownItem
                                disabled={!canGenerate || isBusy}
                                onClick={openDialog}
                            >
                                Write note
                            </DropdownItem>
                            <DropdownItem
                                disabled={isBusy}
                                onClick={() => runReview(beforeReview)}
                            >
                                Review note
                            </DropdownItem>
                        </DropdownContent>
                    </Dropdown>
                );
            }}
        />
    );
}
